import { render } from "./payModel.vue?vue&type=template&id=4b5794ff&scoped=true"
import script from "./payModel.vue?vue&type=script&lang=js"
export * from "./payModel.vue?vue&type=script&lang=js"

import "./payModel.vue?vue&type=style&index=0&id=4b5794ff&scoped=true&lang=scss"

import exportComponent from "/www/wwwroot/manga-official-website/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4b5794ff"]])

export default __exports__